if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
      
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
      
        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
      
        // Reproducción del video al hacer clic y evitar que se pause
        if (activeMedia.nodeName === 'DEFERRED-MEDIA' && activeMediaContent) {
          const videoElement = activeMediaContent.querySelector('video');
          
          if (videoElement) {
            videoElement.muted = true; // Silenciar video para que no bloquee en navegadores que requieran silenciar para autoplay
            videoElement.autoplay = true;
            
            videoElement.play().then(() => {
              console.log('Video reproduciéndose correctamente');
            }).catch((error) => {
              console.error('Error al reproducir el video:', error);
            });
      
            // Agregar un listener para evitar que el video se pause de manera no deseada
            videoElement.addEventListener('pause', () => {
              console.log('Video pausado, forzando reproducción nuevamente');
              videoElement.play();
            });
          }
        }
      
        // Si hay un YouTube video
        if (activeMedia.nodeName === 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube')) {
          activeMedia.loadContent();
        }
      }
      
    }
  );
}
